// Where each kind of user lands after signing in, and who may enter a protected area.
// One place for it: the login page, the Google sign-in callback and ProtectedRoute all
// read from here, so a role can't be routed differently in one of them.

// ops: operations login - the admin panel, limited to the orders dashboard and orders.
const HOME_BY_ROLE = {
  admin: "/admin",
  ops: "/admin",
  distributor: "/distributor",
  reseller: "/reseller",
};

/** The panel a role lands on, or null for a role with no panel (customer, unknown). */
export const homePathForRole = (role) => HOME_BY_ROLE[role] || null;

/** Whether `role` may enter an area that requires `requiredRole` (one role or a list). */
export const canEnter = (requiredRole, role) => !requiredRole || [].concat(requiredRole).includes(role);
